import { Grid, Typography, Box } from "~/components/UI";
import ExpandableTile from "~/components/ExpandableTile";
import EvPortOptions from "./EvPortOptions";

interface EvPortCardProps {
  evPort: Api.EvPortDto;
}

/**
 * @memberof EvPorts
 * @component
 * @desc Render a Card of evPort.
 * @property {Api.EvPortDto} evPort - ev port data;
 */

const EvPortCard = ({ evPort }: EvPortCardProps) => {
  return (
    <ExpandableTile >
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Grid container alignItems="center">
            <Grid item>
              <EvPortOptions evPort={evPort} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Box mb={1}>
        <Typography variant="subtitle1">
          {evPort.portType} (ID: {evPort.id})
        </Typography>
      </Box>
      <Box mb={5}>
        <Typography variant="body2">articleCode: {evPort.articleCode}, {evPort.articleName}</Typography>
      </Box>
    </ExpandableTile>
  );
};

export default EvPortCard;
